import moment from 'moment';

export class Countdown {
  constructor(timeInSeconds, interval = 1000, callback) {
    this.countdown = moment.duration(timeInSeconds, 'seconds');
    this.timer = setInterval(() => {
      if (this.countdown.asSeconds() > 0) {
        this.countdown.subtract(interval / 1000, 'seconds');
        if (callback) {
          callback();
        }
      } else {
        clearInterval(this.timer);
      }
    }, interval);
  }

  stopCountdown() {
    clearInterval(this.timer);
  }

  asSeconds() {
    return this.countdown.asSeconds();
  }

  seconds() {
    return this.countdown.seconds();
  }

  asString() {
    return `${this.leadingZero(this.countdown.minutes())}:${this.leadingZero(
      this.countdown.seconds()
    )}`;
  }

  leadingZero(val) {
    return ('0' + val).slice(-2);
  }
}
